import React from 'react';
import './About.css';
import aboutBanner from '../assets/images/about.jpg';

const About = () => {
  return (
    <div className="about-page-container">
      {/* Banner Section */}
      <div className="about-banner-wrapper">
        <img src={aboutBanner} alt="About Us Banner" className="about-main-banner" />
      </div>

      {/* Main Content Section */}
      <div className="about-text-content">
        <p>COVID-19 changed everything.</p>
        <p>I remember those days clearly. Fear in every home. Silence on the streets. Confusion everywhere. People were scared—not just of the virus, but of what would happen next.</p>
        <p>Around that time, doctors and the World Health Organization spoke about something simple but powerful yoga, breathing, meditation. Not as a cure. But as support. For immunity. For mental strength. For staying calm.</p>
        <p>That is when we started Yoga at Your Home.</p>
        <p>Not with big plans.</p>
        <p>Not with money.</p>
        <p>Just with one thought—people need help, and it should reach their homes.</p>
        <p>We worked with people recovering from COVID-19. We supported families dealing with stress, anxiety, weakness, and fear. Slowly, one person told another. One home led to another. Over time, we were able to help more than 20,000 people.</p>
        <p>We kept our prices affordable. Always.</p>
        <p>Because health should never feel out of reach.</p>
        <p>"India is me."</p>
        <p>When the nation is healthy, individuals thrive. When individuals thrive, the nation grows stronger.</p>
        <p>With this belief, we are now launching "Yoga Karega India"—a long-term movement focused on making yoga available, practical, and trustworthy for every Indian household.</p>
      </div>
    </div>
  );
};

export default About;
